import React from "react";
import { AlertTriangle } from "lucide-react";
import { Card } from "./ui/card";
import { Button } from "./ui/button";

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("UI error boundary:", error, info); }
  reset = () => { this.setState({ hasError: false, error: null }); };
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6">
        <Card className="max-w-md w-full p-6 border-border/60 text-center">
          <AlertTriangle className="w-8 h-8 text-amber-500 mx-auto mb-3" />
          <h2 className="font-heading text-lg font-semibold">Si è verificato un errore</h2>
          <p className="text-sm text-muted-foreground mt-2">La schermata non è riuscita a caricarsi. Prova a ricaricare la pagina.</p>
          <div className="mt-4 flex gap-2 justify-center">
            <Button variant="outline" onClick={this.reset}>Riprova</Button>
            <Button onClick={() => window.location.reload()}>Ricarica</Button>
          </div>
        </Card>
      </div>
    );
  }
}
